import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { showQueryString, showRlsFilterQueryString } from './query-util';
import QueryDetails from './QueryDetails';
import {
  DEFAULT_COLLECTION_FILTERS,
  DEFAULT_SUB_TENANT_COLLECTION_FILTERS,
  DEFAULT_TENANT_COLLECTION_FILTERS,
} from '../../../../common/utils/collectionConstants';
export default class ListDerivedQuery extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    filters: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };
  state = {
    activeFunction: '',
  };

  activateFunction = (name) => {
    if (this.state.activeFunction === name) {
      this.setState({ activeFunction: '' });
    } else {
      this.setState({ activeFunction: name });
    }
  };

  showQuery = (filter) => {
    const { projectCollections } = this.props.collections;
    const { rls } = this.props;
    if (rls) {
      return showRlsFilterQueryString(filter, projectCollections);
    } else {
      return showQueryString(filter, projectCollections);
    }
  };

  showFilterTypeIcon(finder) {
    switch (finder) {
      case 'FIND':
        return <i className="webconnect webconnect-file-binary"></i>;
      case 'FIND_ALL':
        return <i className="webconnect webconnect-files"></i>;
      case 'COUNT':
        return <i className="webconnect webconnect-file-earmark-binary-fill"></i>;
      case 'SUM':
        return <i className="webconnect webconnect-file-plus"></i>;
      case 'AVG':
        return <i className="webconnect webconnect-file-earmark-diff"></i>;
      case 'MAX':
        return <i className="webconnect webconnect-file-post"></i>;
      default:
        return <i className="webconnect webconnect-file-post-fill"></i>;
    }
  }
  isSystemDefault = (filterName) => {
    let isSystemDefault = false;
    if (filterName && DEFAULT_COLLECTION_FILTERS.includes(filterName)) {
      isSystemDefault = true;
    }
    return isSystemDefault;
  };
  isTenantDefault = (filterName) => {
    let isTenantDefault = false;
    if (filterName && DEFAULT_TENANT_COLLECTION_FILTERS.includes(filterName)) {
      isTenantDefault = true;
    }
    return isTenantDefault;
  };
  isSubTenantDefault = (filterName) => {
    let isSubTenantDefault = false;
    if (filterName && DEFAULT_SUB_TENANT_COLLECTION_FILTERS.includes(filterName)) {
      isSubTenantDefault = true;
    }
    return isSubTenantDefault;
  };
  showQueryDetails = (filter) => {
    const {
      collection,
      projectId,
      actions,
      commonActions,
      showFilterDeleteLoader,
      collections,
      version,
      flag,
      rls,
    } = this.props;
    return (
      <AccordionItem key={filter.name}>
        <AccordionItemHeading>
          <AccordionItemButton>
            {this.showFilterTypeIcon(filter.finder)}
            <strong>{filter.name}</strong>
            {this.isSystemDefault(filter.name)
              ? ` (system default)`
              : this.isTenantDefault(filter.name)
              ? ` (tenant default)`
              : this.isSubTenantDefault(filter.name)
              ? ` (Sub Tenant default)`
              : ''}
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <QueryDetails
            filter={filter}
            collection={collection}
            projectId={projectId}
            version={version}
            actions={actions}
            commonActions={commonActions}
            showQuery={this.showQuery}
            showFilterDeleteLoader={showFilterDeleteLoader}
            collections={collections}
            flag={flag}
            rls={rls}
          />
        </AccordionItemPanel>
      </AccordionItem>
    );
  };

  render() {
    const { filters, rls } = this.props;
    const systemDefaultFilters = [];
    const tenantDefaultFilters = [];
    const userDefinedFilters = [];
    const subTenantDefaultFilters = [];

    filters &&
      filters.length > 0 &&
      filters.map((filter) => {
        if (this.isSystemDefault(filter.name)) {
          systemDefaultFilters.push(filter);
        } else if (this.isTenantDefault(filter.name)) {
          tenantDefaultFilters.push(filter);
        } else if (this.isSubTenantDefault(filter.name)) {
          subTenantDefaultFilters.push(filter);
        } else {
          userDefinedFilters.push(filter);
        }
      });

    if (filters && filters.length > 0) {
      return (
        <div className="row modal-scroll">
          <div className="col-12">
            {systemDefaultFilters && systemDefaultFilters.length > 0 && (
              <Accordion allowZeroExpanded>
                {systemDefaultFilters.map((filter) => this.showQueryDetails(filter))}
              </Accordion>
            )}
            {tenantDefaultFilters && tenantDefaultFilters.length > 0 && (
              <Accordion allowZeroExpanded>
                {tenantDefaultFilters.map((filter) => this.showQueryDetails(filter))}
              </Accordion>
            )}
            {subTenantDefaultFilters && subTenantDefaultFilters.length > 0 && (
              <Accordion allowZeroExpanded>
                {subTenantDefaultFilters.map((filter) => this.showQueryDetails(filter))}
              </Accordion>
            )}
            {userDefinedFilters && userDefinedFilters.length > 0 && (
              <Accordion allowZeroExpanded>
                {userDefinedFilters.map((filter) => this.showQueryDetails(filter))}
              </Accordion>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <h5 className="text-center">{rls ? 'No Row Level Security Filters!' : 'No Filters!'}</h5>
        </div>
      );
    }
  }
}
